import { usePermissionRestriction } from '@shared/hooks'
import { AppPermissions } from '@shared/types'
import { Button, ButtonProps } from 'antd'
import { useState } from 'react'

import { CommonType } from './types'
import { VehicleModalSelect } from './VehicleModalSelect'

type Props<M extends boolean> = CommonType<M> & Omit<ButtonProps, 'value'>

export function AddVehicleButton<M extends boolean>({
  multiple,
  value,
  vehicleType,
  onAdd,
  getTitle,
  getSubtitle,
  getExtra,
  ...props
}: Props<M>) {
  const { hasPermission } = usePermissionRestriction()
  const [isOpen, setIsOpen] = useState(false)

  const triggerModal = () => setIsOpen((isOpen) => !isOpen)

  if (!hasPermission([AppPermissions.SECTION_CUSTOMERS])) return

  return (
    <>
      <Button onClick={triggerModal} {...props} />

      <VehicleModalSelect
        multiple={multiple}
        open={isOpen}
        value={value}
        vehicleType={vehicleType}
        onCancel={triggerModal}
        onAdd={onAdd}
        getTitle={getTitle}
        getSubtitle={getSubtitle}
        getExtra={getExtra}
      />
    </>
  )
}
